import { render, staticRenderFns } from "./SnomedBrowserLicenceComponent.vue?vue&type=template&id=09c50758&scoped=true"
import script from "./SnomedBrowserLicenceComponent.vue?vue&type=script&lang=js"
export * from "./SnomedBrowserLicenceComponent.vue?vue&type=script&lang=js"
import style0 from "./SnomedBrowserLicenceComponent.vue?vue&type=style&index=0&id=09c50758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c50758",
  null
  
)

export default component.exports